import React, { useContext, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { LanguageProvider, LanguageContext } from './LanguageContext';
import config from './config';
import projets from './projets';
import Navbar from './components/Navbar';
import HomepageContent from './components/HomepageContent';
import About from './components/About';
import Projets from './components/Projets';
import ProjetDetail from './components/ProjetDetail';
import Contact from './components/Contact';
import NotFound from './components/NotFound';
import Pavebas from './components/Pavebas';

// Remonte en haut de page à chaque changement de page
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => AOS.refresh(), 50);
  }, [pathname]);
  return null;
};

// Met à jour le titre de l'onglet (utile pour le référencement et l'historique)

const PageTitle = () => {
  const { pathname } = useLocation();
  const { language } = useContext(LanguageContext);

  useEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';

    let title = '';
    let description = '';

    if (path === '/') {
      title = language === 'fr'
        ? 'Fiat Architecte | Architecte à Nice'
        : 'Fiat Architect | Architect in Nice';

      description = language === 'fr'
        ? "Fiat Architecte à Nice : conception architecturale, logements, bâtiments publics, rénovation et réhabilitation. Découvrez mes réalisations et parlons de votre projet."
        : "Fiat Architect in Nice, France: architectural design, housing, public buildings, renovation and rehabilitation. Discover my projects and get in touch.";
    } else if (path === '/about') {
      title = language === 'fr'
        ? 'À propos | Fiat Architecte à Nice'
        : 'About | Fiat Architect in Nice';

      description = language === 'fr'
        ? "Découvrez l'approche et le parcours de Fiat Architecte, cabinet d'architecture à Nice, spécialisé dans les projets de logements et bâtiments publics."
        : "Discover the approach and work of Fiat Architect, an architecture practice in Nice, France.";
    } else if (path === '/projets') {
      title = language === 'fr'
        ? 'Projets et réalisations | Fiat Architecte'
        : 'Projects and Portfolio | Fiat Architect';

      description = language === 'fr'
        ? "Découvrez les projets de Fiat Architecte : établissements de santé, bâtiments scolaires, construction, rénovation et réhabilitation."
        : "Explore Fiat Architect's architectural projects, including healthcare facilities, schools, construction and renovation.";
    } else if (path === '/contact') {
      title = language === 'fr'
        ? 'Contact | Fiat Architecte à Nice'
        : 'Contact | Fiat Architect in Nice';

      description = language === 'fr'
        ? "Vous avez un projet de construction, de rénovation ou de réhabilitation ? Contactez Fiat Architecte à Nice pour en discuter."
        : "Have a construction, renovation or rehabilitation project? Contact Fiat Architect in Nice, France.";
    } else if (path.startsWith('/projets/')) {
      const slug = path.split('/')[2];
      const projet = projets.find((p) => p.slug === slug);

      if (projet) {
        const name = projet.name[language];
        const place = projet.place ? ` – ${projet.place}` : '';

        title = `${name}${place} | Fiat Architecte`;

        description = projet.description[language] ||
          (language === 'fr'
            ? `${name}${place}. Découvrez cette réalisation de Fiat Architecte.`
            : `${name}${place}. Discover this project by Fiat Architect.`);
      }
    }

    if (!title) {
      title = language === 'fr'
        ? `Page introuvable | ${config.name}`
        : `Page not found | ${config.name}`;

      description = language === 'fr'
        ? 'La page demandée est introuvable.'
        : 'The requested page could not be found.';
    }

    document.title = title;

    let metaDescription = document.querySelector(
      'meta[name="description"]'
    );

    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }

    metaDescription.setAttribute('content', description);

  }, [pathname, language]);

  return null;
};


const App = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 60 });
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <ScrollToTop />
        <PageTitle />
        <div className="site">
          <Navbar />
          <main className="site-main">
            <Routes>
              <Route path="/" element={<HomepageContent />} />
              <Route path="/about" element={<About />} />
              <Route path="/projets" element={<Projets />} />
              <Route path="/projets/:slug" element={<ProjetDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </main>
          <Pavebas />
        </div>
      </Router>
    </LanguageProvider>
  );
};

export default App;
